<template>
  <div class="admin-layout">
    <!-- Top App Bar -->
    <AppHeader @toggle-sidebar="mobileDrawer = !mobileDrawer" />

    <!-- Mobile Drawer -->
    <v-navigation-drawer
      v-model="mobileDrawer"
      temporary
      fixed
      color="#ffffff"
      style="z-index: 9999;"
      width="260"
    >
      <div class="sidebar-inner">
        <nav class="sidebar-nav">
          <div v-for="(item, i) in menus" :key="i">
            <div
              class="nav-item"
              :class="{ 'nav-item--active': isGroupActive(item) && !openGroups[i], 'nav-item--open': openGroups[i] }"
              @click="toggleGroup(i)"
            >
              <span class="nav-item__icon-wrap" :class="{ 'nav-item__icon-wrap--active': isGroupActive(item) || openGroups[i] }">
                <v-icon size="18">{{ item.icon }}</v-icon>
              </span>
              <span class="nav-item__label">{{ item.name }}</span>
              <v-icon size="16" class="nav-item__chevron" :class="{ 'nav-item__chevron--open': openGroups[i] }">
                mdi-chevron-right
              </v-icon>
            </div>

            <transition name="slide-down">
              <div v-if="openGroups[i]" class="sub-nav">
                <router-link
                  v-for="(sub, j) in item.subMenu"
                  :key="j"
                  :to="sub.route"
                  class="sub-nav__item"
                  :class="{ 'sub-nav__item--active': $route.path === sub.route }"
                  @click.native="mobileDrawer = false"
                >
                  <span class="sub-nav__dot" :class="{ 'sub-nav__dot--active': $route.path === sub.route }"></span>
                  {{ sub.name }}
                </router-link>
              </div>
            </transition>
          </div>
        </nav>
      </div>
    </v-navigation-drawer>

    <!-- Body -->
    <div class="admin-body">

      <!-- Desktop Sidebar -->
      <aside class="sidebar hidden-md-and-down">
        <div class="sidebar-inner">
          <nav class="sidebar-nav">
            <div v-for="(item, i) in menus" :key="i">
              <div
                class="nav-item"
                :class="{ 'nav-item--active': isGroupActive(item) && !openGroups[i], 'nav-item--open': openGroups[i] }"
                @click="toggleGroup(i)"
              >
                <span class="nav-item__icon-wrap" :class="{ 'nav-item__icon-wrap--active': isGroupActive(item) || openGroups[i] }">
                  <v-icon size="18">{{ item.icon }}</v-icon>
                </span>
                <span class="nav-item__label">{{ item.name }}</span>
                <v-icon size="16" class="nav-item__chevron" :class="{ 'nav-item__chevron--open': openGroups[i] }">
                  mdi-chevron-right
                </v-icon>
              </div>

              <transition name="slide-down">
                <div v-if="openGroups[i]" class="sub-nav">
                  <router-link
                    v-for="(sub, j) in item.subMenu"
                    :key="j"
                    :to="sub.route"
                    class="sub-nav__item"
                    :class="{ 'sub-nav__item--active': $route.path === sub.route }"
                  >
                    <span class="sub-nav__dot" :class="{ 'sub-nav__dot--active': $route.path === sub.route }"></span>
                    {{ sub.name }}
                  </router-link>
                </div>
              </transition>
            </div>
          </nav>
        </div>
      </aside>

      <!-- Main content -->
      <main class="main-content">
        <router-view :key="$route.fullPath"></router-view>
      </main>
    </div>
  </div>
</template>

<script>
import AppHeader from "./Header.vue";
export default {
  components: { AppHeader },
  data() {
    return {
      mobileDrawer: false,
      openGroups: {},
      menus: [
        {
          name: "Dashboard",
          icon: "mdi-view-dashboard-outline",
          subMenu: [{ name: "Dashboard", route: "/dashboard" }],
        },
        {
          name: "Home",
          icon: "mdi-home-outline",
          subMenu: [
            { name: "Home Slider", route: "/homeSlider" },
            { name: "Middle Slider", route: "/middleSlider" },
          ],
        },
        {
          name: "User List",
          icon: "mdi-account-group-outline",
          subMenu: [
            { name: "Customer List", route: "/customerList" },
            { name: "Pending Seller List", route: "/pendingSeller" },
            { name: "Seller List", route: "/SellerList" },
          ],
        },
        {
          name: "User Review",
          icon: "mdi-star-outline",
          subMenu: [{ name: "Reviews", route: "/reviewList" }],
        },
        {
          name: "Category",
          icon: "mdi-shape-outline",
          subMenu: [
            { name: "Main Category", route: "/mainCategory" },
            { name: "Category", route: "/category" },
            { name: "Sub-Category", route: "/subCategory" },
          ],
        },
        {
          name: "Product",
          icon: "mdi-package-variant-closed",
          subMenu: [
            { name: "Pending Product", route: "/pendingProducts" },
            { name: "Updated Product", route: "/updatedProduct" },
            { name: "Rejected Product", route: "/rejectedProduct" },
            { name: "Product", route: "/product" },
          ],
        },
        {
          name: "Promo Code",
          icon: "mdi-ticket-percent-outline",
          subMenu: [
            { name: "Promo Code", route: "/productPromoCode" },
            { name: "Pending Promo Code", route: "/pendingPromoCode" },
            { name: "Updated Promo Code", route: "/updatedPromoCode" },
          ],
        },
        {
          name: "Notification",
          icon: "mdi-bell-outline",
          subMenu: [{ name: "Notification", route: "/notification" }],
        },
        {
          name: "Promotional Email",
          icon: "mdi-email-outline",
          subMenu: [{ name: "Campaigns", route: "/emailCampaign" }],
        },
        {
          name: "Reports",
          icon: "mdi-chart-bar",
          subMenu: [
            { name: "Sales Report", route: "/salesReport" },
            { name: "Inventory Report", route: "/inventoryReport" },
          ],
        },
        {
          name: "Order",
          icon: "mdi-cart-outline",
          subMenu: [
            { name: "Order List", route: "/orderList" },
            { name: "Cancelled List", route: "/cancelledList" }
          ],
        },
        {
          name: "Contact",
          icon: "mdi-phone-outline",
          subMenu: [{ name: "Contact List", route: "/contactList" }],
        },
        {
          name: "Footer",
          icon: "mdi-page-layout-footer",
          subMenu: [{ name: "Footer Data", route: "/footerData" }],
        },
        {
          name: "Terms and conditions",
          icon: "mdi-file-document-outline",
          subMenu: [
            { name: "Privacy policy", route: "/static/Privacy Policy" },
            { name: "Cancellation policy", route: "/static/Cancellation Policy" },
            { name: "Terms and conditions", route: "/static/Terms and conditions" },
            { name: "Shipping and Delivery", route: "/static/Shipping and Delivery" },
            { name: "About Us", route: "/static/About Us" },
          ],
        },
      ],
    };
  },
  methods: {
    toggleGroup(i) {
      const isOpen = this.openGroups[i];
      this.openGroups = {};
      if (!isOpen) {
        this.$set(this.openGroups, i, true);
      }
    },
    isGroupActive(item) {
      return item.subMenu.some((s) => this.$route.path === s.route);
    },
    autoOpenActive() {
      this.openGroups = {};
      this.menus.forEach((item, i) => {
        if (this.isGroupActive(item)) {
          this.$set(this.openGroups, i, true);
        }
      });
    },
  },
  mounted() {
    this.autoOpenActive();
  },
  watch: {
    $route() {
      this.autoOpenActive();
    },
  },
};
</script>

<style scoped>
/* ─── Layout Shell ─────────────────────────────── */
.admin-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #f4f6f8;
}

.admin-body {
  display: flex;
  flex: 1;
}

/* ─── Desktop Sidebar ──────────────────────────── */
.sidebar {
  width: 230px;
  min-width: 230px;
  background: #ffffff;
  border-right: 1px solid #eaedf0;
  height: 100vh;
  position: sticky;
  top: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.sidebar-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #e0e0e0 transparent;
  padding: 8px 0 32px;
}

.sidebar-inner::-webkit-scrollbar {
  width: 4px;
}
.sidebar-inner::-webkit-scrollbar-track {
  background: transparent;
}
.sidebar-inner::-webkit-scrollbar-thumb {
  background: #e0e0e0;
  border-radius: 4px;
}

/* ─── Nav ──────────────────────────────────────── */
.sidebar-nav {
  padding: 0 10px;
}

/* ─── Parent Nav Item ───────────────────────────── */
.nav-item {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 10px 12px;
  border-radius: 10px;
  cursor: pointer;
  color: #5a6478;
  transition: background 0.18s, color 0.18s;
  user-select: none;
  margin-bottom: 2px;
}

.nav-item:hover {
  background: #f0faf4;
  color: #2e9e60;
}

.nav-item--active {
  background: #e8f7ee;
  color: #2e9e60;
}

.nav-item--open {
  background: #e8f7ee;
  color: #2e9e60;
}

/* Icon bubble */
.nav-item__icon-wrap {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.18s;
}

.nav-item__icon-wrap .v-icon {
  color: #8a93a4 !important;
  transition: color 0.18s;
}

.nav-item__icon-wrap--active {
  background: #d6f0e3;
}

.nav-item__icon-wrap--active .v-icon {
  color: #2e9e60 !important;
}

.nav-item:hover .nav-item__icon-wrap {
  background: #d6f0e3;
}

.nav-item:hover .nav-item__icon-wrap .v-icon {
  color: #2e9e60 !important;
}

.nav-item__label {
  flex: 1;
  text-align: left;
  font-size: 13px;
  font-family: poppinssemibold, sans-serif;
  line-height: 1;
  letter-spacing: 0.1px;
}

.nav-item__chevron {
  color: #b0bac8 !important;
  transition: transform 0.22s ease;
  flex-shrink: 0;
}

.nav-item__chevron--open {
  transform: rotate(90deg);
  color: #2e9e60 !important;
}

/* ─── Sub-items ────────────────────────────────── */
.sub-nav {
  padding: 2px 0 6px 44px;
}

.sub-nav__item {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 7px 10px;
  border-radius: 7px;
  font-size: 12.5px;
  font-family: poppinsmedium, sans-serif;
  color: #7a8499;
  text-decoration: none;
  transition: background 0.15s, color 0.15s;
  margin-bottom: 1px;
  text-align: left;
}

.sub-nav__item:hover {
  background: #f0faf4;
  color: #2e9e60;
}

.sub-nav__item--active {
  color: #2e9e60 !important;
  font-family: poppinsbold, sans-serif !important;
}

.sub-nav__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #d0d5de;
  flex-shrink: 0;
  transition: background 0.15s, transform 0.15s;
}

.sub-nav__dot--active {
  background: #2e9e60;
  transform: scale(1.3);
}

/* ─── Slide-down animation ─────────────────────── */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: max-height 0.25s ease, opacity 0.2s ease;
  max-height: 400px;
  overflow: hidden;
  opacity: 1;
}

.slide-down-enter,
.slide-down-leave-to {
  max-height: 0;
  opacity: 0;
}

/* ─── Main Content ─────────────────────────────── */
.main-content {
  flex: 1;
  padding: 24px;
  background: #f4f6f8;
  min-height: 100vh;
  overflow-y: auto;
}

/* ─── Mobile padding fix ───────────────────────── */
@media (max-width: 1263px) {
  .main-content {
    padding-top: 0px !important;
  }
}
</style>
